
import requestManager from '@/components/platformApi/requestManager';

import axios from '@util/axios';
import appHelper from '@/util/appHelper';

export default {

    verifyLogin : {
        method: 'post',
        url: 'login/portal/verify_login'
    },

    /**
     * @param   {Object}    params
     * @param   {String}    params.loginName
     * @param   {String}    params.password
     * @param   {String}    params.verificationCode
     * @param   {Function}  callback
     */
    login : function(params, callback) {
        requestManager.request({
            url: 'login/portal/login',
            method: 'post',
            data : params
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        })
    },

    logout : function(callback) {
        requestManager.request({
            url: 'login/portal/logout',
            method: 'post'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        });
    },

    isBindPhone : {
        method: 'post',
        url: 'login/isBindPhone'
    },

    getBindPhoneStatus(callback) {
        requestManager.request({
            url: 'login/isBindPhone',
            method: 'post'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result.data);
        });
    },

    settingInfo : function() {
        return axios({
            method: 'get',
            url: 'api/v1/my/setting/settingInfo'
        });
    },

    wxAuth : function(params) {
        return axios({
            method: 'get',
            url: '/wxLogin/auth',
            params : params
        })
    },

    sendVerifyCodeApi : {
        method: 'post',
        url: '/login/sendMsgVerifyCode',
    },

    sendVerifyCodeAction : function(phone, callback) {
        requestManager.request({
            url: 'login/sendMsgVerifyCode',
            method: 'post',
            data : { phone : phone }
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result);
        });
    },

    verifyPhoneCode : function(params) {
        return axios({
            method: 'put',
            url: '/captcha',
            data: params
        })
    },

    verifyPhoneCodeApi : {
        method: 'post',
        // url: '/captcha'
        url: '/login/msgVerifyCode'
    },

    bindPhone : {
        method: 'post',
        url: 'login/bindPhone'
    },

    bindPhoneAction(data, callback) {
        requestManager.request({
            url: 'login/bindPhone',
            method: 'post',
            data : data
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result);
        })
    },

    resetPassword : function(params) {
        return axios({
            method: 'put',
            url: '/login/reset',
            data: params
        })
    },

    updateInfo : function (data) {
        return axios({
            method: 'put',
            url: 'api/v1/my/info',
            data: data
        })
    },

    userTotalIntegral : {
        url: 'portal/v4/user/center/userTotalIntegral'
    },

    getUserData:{
        url : '/portal/v4/user/center/getUserInfo',
    },

    loadUserInfo(callback) {
        requestManager.request({
            url: 'portal/v4/user/center/getUserInfo'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result.data);
        })
    },

    getHobbyList(callback) {
        requestManager.request({
            url: 'portal/user/user/getHobbyList'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result.data);
        })
    },

    getEduList(callback) {
        requestManager.request({
            url: 'portal/user/user/getEdu'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result.data);
        })
    },

    getProfessionList(callback) {
        requestManager.request({
            url: 'portal/user/user/getProfessionList'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result.data);
        })
    },

    /**
     * @param   {Function}  callback
     */
    getUserNewMessageCount(callback) {
        requestManager.request({
            url: 'portal/message/getUserNewMessageCount'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result.data);
        });
    },

    /**
     * @param   {Function}  callback
     */
    isCompleteIdInfo(callback) {
        requestManager.request({
            url: 'portal/v2/account/isCompleteIdInfo'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result.data);
        });
    },

    /**
     * @param   {Function}  callback
     */
    getUserVipInfo(callback) {
        requestManager.request({
            url: 'portal/user/vip/getUserVip'
        }, (error, result) => {

            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint('错误代码：' + result.errorCode + ' ' + result.msg);
                return;
            }

            callback(result.data);
        });
    }


};
